// Lint exception: We want to log messages
import { useEffect, useState } from "react";

import { usePlatform } from "../platform-detection/use-platform.js";
import { loginRequest, msalConfig } from "./msal-config.js";
import type { AuthService } from "./services/auth-service.interface.ts";
import { createMsalAuthService } from "./services/msal-auth.service.js";
import { createTeamsAuthService } from "./services/teams-auth.service.js";

export function useAuthService() {
  const { safeOperation } = usePlatform();
  const [authService, setAuthService] = useState<AuthService | null>(null);

  useEffect(() => {
    const setServiceBasedOnPlatform = async () => {
      const service = await safeOperation(
        () => {
          const teamsService = createTeamsAuthService();
          console.log("[useAuthService] Using Teams auth service");
          return teamsService;
        },

        () => {
          const msalService = createMsalAuthService({
            loginRequest,
            msalConfig,
          });

          console.log("[useAuthService] Using MSAL auth service");
          return msalService;
        }
      );

      setAuthService(service);
    };

    setServiceBasedOnPlatform();
  }, [safeOperation]);

  return {
    authService,
  };
}
